export default "__VITE_ASSET__4XiLtvr4__"